import React, { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import useApi from '../../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import { TextareaField } from '../../../../../utils/InputField';
import { useInvoiceInfo } from '../InvoiceInfoProvider';

function ModalConvertQuotationToInvoice() {
    const { closeModal, setMessage, modalData } = useTemplate();
    const { handleReload } = useInvoiceInfo();

    const { put } = useApi();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const [formData, setFormData] = useState({
        Id: modalData?.id || 0,
        InvoiceComment: modalData?.comment || ''
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name) {
            setFormData((prevData) => ({ ...prevData, [name]: value }));
        }
    };

    const handleSubmit = (e) => {
        e?.preventDefault();
        setLoading(true);
        put(`api/invoices/${formData.Id}/convert-quotation-to-invoice`, formData)
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                setMessage({ type: 'success', text: message });
                closeModal();
                handleReload();
            })
            .catch((ex) => {
                setMessage({ type: 'error', text: ex.message });
            })
            .finally(() => setLoading(false));
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSubmit}>
            <div className="flex flex-col gap-y-3 mb-5">
                <TextareaField
                    label="Comment"
                    name="InvoiceComment"
                    placeholder="Type your comment..."
                    formData={formData}
                    onChange={handleChange}
                    className="h-36"
                    optional
                />
            </div>

            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Submit" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ModalConvertQuotationToInvoice;
